import { render, staticRenderFns } from "./DashboardTotaisCard.vue?vue&type=template&id=98dcef2a&scoped=true&"
import script from "./DashboardTotaisCard.vue?vue&type=script&lang=js&"
export * from "./DashboardTotaisCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTotaisCard.vue?vue&type=style&index=0&id=98dcef2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dcef2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VIcon})
